import { render } from "./PasswordForm.vue?vue&type=template&id=30f65630&ts=true"
import script from "./PasswordForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__